import { withStyles } from '@mui/styles';
import { Button } from '@mui/material';

const DangerButton = withStyles(() => ({
  root: {
    color: '#f8f8f8',
    backgroundColor: '#D8274A',
    '&:hover': {
      backgroundColor: '#D8274A',
    },
    '&:disabled': {
      backgroundColor: '#bdbdbd',
      color: '#424242',
    },
  },
}))(Button);

export default DangerButton;
